import { locales as baseLocales } from "../locales/locales.js";

export const sharerLocales = {
  sms: {
    en: "SMS",
    de: "SMS",
    fr: "SMS",
    ca: "SMS",
    es: "SMS",
    nl: "SMS",
    da: "SMS",
    "pt-BR": "SMS",
    ru: "SMS",
    it: "SMS",
  },
  messenger: {
    en: "Messenger",
    de: "Messenger",
    fr: "Messenger",
    ca: "Messenger",
    es: "Messenger",
    nl: "Messenger",
    da: "Messenger",
    "pt-BR": "Messenger",
    ru: "Messenger",
    it: "Messenger",
  },
  whatsapp: {
    en: "WhatsApp",
    de: "WhatsApp",
    fr: "WhatsApp",
    ca: "WhatsApp",
    es: "WhatsApp",
    nl: "WhatsApp",
    da: "WhatsApp",
    "pt-BR": "WhatsApp",
    ru: "WhatsApp",
    it: "WhatsApp",
  },
  twitter: {
    en: "Twitter",
    de: "Twitter",
    fr: "Twitter",
    ca: "Twitter",
    es: "Twitter",
    nl: "Twitter",
    da: "Twitter",
    "pt-BR": "Twitter",
    ru: "Twitter",
    it: "Twitter",
  },
  linkedin: {
    en: "Linkedin",
    de: "Linkedin",
    fr: "Linkedin",
    ca: "Linkedin",
    es: "Linkedin",
    nl: "Linkedin",
    da: "Linkedin",
    "pt-BR": "Linkedin",
    ru: "Linkedin",
    it: "Linkedin",
  },
  telegram: {
    en: "Telegram",
    de: "Telegram",
    fr: "Telegram",
    ca: "Telegram",
    es: "Telegram",
    nl: "Telegram",
    da: "Telegram",
    "pt-BR": "Telegram",
    ru: "Telegram",
    it: "Telegram",
  },
  facebook: {
    en: "Facebook",
    de: "Facebook",
    fr: "Facebook",
    ca: "Facebook",
    es: "Facebook",
    nl: "Facebook",
    da: "Facebook",
    "pt-BR": "Facebook",
    ru: "Facebook",
    it: "Facebook",
  },
  pinterest: {
    en: "Pinterest",
    de: "Pinterest",
    fr: "Pinterest",
    ca: "Pinterest",
    es: "Pinterest",
    nl: "Pinterest",
    da: "Pinterest",
    "pt-BR": "Pinterest",
    ru: "Pinterest",
    it: "Pinterest",
  },
  shareTitle: {
    en: "Share",
    de: "Teilen",
    fr: "Partager",
    ca: "Share",
    es: "Compartir",
    nl: "Delen",
    da: "Del",
    "pt-BR": "Compartilhar",
    ru: "Поделиться",
    it: "Share",
  },
  cancel: {
    en: "Cancel",
    de: "Abbrechen",
    fr: "Annuler",
    ca: "Cancel",
    es: "Cancelar",
    nl: "Annuleren",
    da: "Luk",
    "pt-BR": "Cancelar",
    ru: "Отмена",
    it: "Cancel",
  },
  copy: {
    en: "Copy",
    de: "Kopieren",
    fr: "Copier",
    ca: "Copy",
    es: "Copiar",
    nl: "Kopiëren",
    da: "Kopiér",
    "pt-BR": "Copiar",
    ru: "Скопировать",
    it: "Copy",
  },
  print: {
    en: "Print",
    de: "Drucken",
    fr: "Imprimer",
    ca: "Print",
    es: "Imprimir",
    nl: "Printen",
    da: "Udskriv",
    "pt-BR": "Imprimir",
    ru: "Печать",
    it: "",
  },
  email: {
    en: "E-mail",
    de: "E-mail",
    fr: "E-mail",
    ca: "E-mail",
    es: "Correo",
    nl: "E-mail",
    da: "E-mail",
    "pt-BR": "E-mail",
    ru: "Э-майл",
    it: "E-mail",
  },
  selectSms: {
    en: "Pick a contact",
    de: "Wählen Sie einen Kontakt aus",
    fr: "Veuillez choisir un contact",
    ca: "Pick a contact",
    es: "Seleccionar un contacto",
    nl: "Selecteer een contact",
    da: "Vælg en kontaktperson",
    "pt-BR": "Selecione um contato",
    ru: "Выбери контакт",
    it: "Pick a contact",
  },
};

let supportedLanguages = [
  "en",
  "cy",
  "it",
  "fr",
  "de",
  "es",
  "ca",
  "nl",
  "da",
  "pt-BR",
  "ru",
];

/** Checks if a language is supported */
export const localeAvailable = (locale) => {
  return supportedLanguages.indexOf(locale) >= 0;
};

export function availableLocales() {
  return supportedLanguages;
}

// Extend this to include _CassisLocales
// Also, let's forget about unit testing this for now
/* c8 ignore next 15 */
function createLocales() {
  return function (a, extraLocales) {
    const locales = Object.assign({}, extraLocales, a);
    if ("_CassisLocales" in window) {
      const extraLocales = window._CassisLocales;
      for (const extraLocale of extraLocales) {
        supportedLanguages = supportedLanguages.concat(extraLocale.lang);
        for (const key of Object.keys(a)) {
          locales[key] = Object.assign(a[key], extraLocale.locale[key]);
        }
      }
    }
    return locales;
  };
}

// The PDF reader's own strings, kept here rather than in the CSV shared
// with the EPUB reader.
export const pdfLocales = {
  outdatedBrowser: {
    en: "This book can't be displayed in this browser.",
    cy: "Does dim modd dangos y llyfr hwn yn y porwr hwn.",
    it: "Questo libro non può essere visualizzato in questo browser.",
    fr: "Ce livre ne peut pas s'afficher dans ce navigateur.",
    de: "Dieses Buch kann in diesem Browser nicht angezeigt werden.",
    es: "Este libro no se puede mostrar en este navegador.",
    ca: "Aquest llibre no es pot mostrar en aquest navegador.",
    nl: "Dit boek kan niet worden weergegeven in deze browser.",
    da: "Denne bog kan ikke vises i denne browser.",
    "pt-BR": "Este livro não pode ser exibido neste navegador.",
    ru: "Эту книгу невозможно показать в этом браузере.",
  },
  outdatedBrowserAdvice: {
    en: "Your browser or your device's software is probably out of date. Updating your browser or device, or opening this page in another up-to-date browser, should fix this.",
    cy: "Mae'n debyg bod eich porwr neu feddalwedd eich dyfais wedi dyddio. Dylai diweddaru'r porwr neu feddalwedd y ddyfais, neu agor y dudalen hon mewn porwr cyfredol arall, ddatrys hyn.",
    it: "Probabilmente il browser o il software del dispositivo non è aggiornato. Aggiornarlo, oppure aprire questa pagina in un altro browser aggiornato, dovrebbe risolvere il problema.",
    fr: "Votre navigateur ou le logiciel de votre appareil n'est probablement pas à jour. Le mettre à jour, ou ouvrir cette page dans un autre navigateur à jour, devrait résoudre le problème.",
    de: "Ihr Browser oder die Software Ihres Geräts ist wahrscheinlich veraltet. Eine Aktualisierung oder das Öffnen dieser Seite in einem anderen, aktuellen Browser sollte das Problem beheben.",
    es: "Probablemente su navegador o el software de su dispositivo no esté actualizado. Actualizarlo, o abrir esta página en otro navegador actualizado, debería solucionarlo.",
    ca: "Probablement el vostre navegador o el programari del dispositiu no està actualitzat. Actualitzar-lo, o obrir aquesta pàgina en un altre navegador actualitzat, ho hauria de solucionar.",
    nl: "Uw browser of de software van uw apparaat is waarschijnlijk verouderd. Bijwerken, of deze pagina openen in een andere, actuele browser, zou dit moeten verhelpen.",
    da: "Din browser eller din enheds software er sandsynligvis forældet. Hvis du opdaterer den eller åbner siden i en anden opdateret browser, bør det løse problemet.",
    "pt-BR":
      "Seu navegador ou o software do seu dispositivo provavelmente está desatualizado. Atualizá-lo, ou abrir esta página em outro navegador atualizado, deve resolver o problema.",
    ru: "Вероятно, ваш браузер или программное обеспечение устройства устарели. Обновите их или откройте эту страницу в другом, актуальном браузере.",
  },
};

export const locales = createLocales()(baseLocales, {
  ...sharerLocales,
  ...pdfLocales,
});
